import React from "react";
import { obterStatusCadastro } from "../../actions/MotoristaActions";
import TopoSemMenuComLogoutEVoltar from "../../components/TopoSemMenuComLogoutEVoltar";
import StatusAprovado from "./components/StatusAprovado";
import StatusPendente from "./components/StatusPendente";
import StatusReprovado from "./components/StatusReprovado";

export default class CadastroAcompanhamento extends React.Component {
  constructor(props) {
    super();
    this.state = {
      Status: StatusPendente,
    };
  }

  componentDidMount = async () => {
    let motorista_logado = localStorage.getItem("motorista_logado");

    if (motorista_logado) {
      motorista_logado = JSON.parse(motorista_logado);

      if (motorista_logado.email) {
        let status = null;
        const statusCadastro = await obterStatusCadastro(motorista_logado.email);

        if ([3, 4, 6, 7, 13, 14].includes(statusCadastro.idc_status)) {
          status = StatusPendente;
        } else if ([2, 9, 10, 11].includes(statusCadastro.idc_status)) {
          status = StatusReprovado;
        } else if ([1, 5].includes(statusCadastro.idc_status)) {
          status = StatusAprovado;
        } else if (statusCadastro.idc_status === 8) {
          if (statusCadastro.idc_termo_aceito === 1) {
            window.location = "/home";
          } else {
            status = StatusAprovado;
          }
        } else {
          window.location = "/login";
        }

        this.setState({ Status: status });
      } else {
        window.location = "/login";
      }
    } else {
      window.location = "/login";
    }
  };

  render() {
    return (
      <div>
        <TopoSemMenuComLogoutEVoltar />
        <this.state.Status />
      </div>
    );
  }
}
